var render, staticRenderFns
import script from "./HeartbeatMarker.vue?vue&type=script&lang=js&"
export * from "./HeartbeatMarker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10a3b918')) {
      api.createRecord('10a3b918', component.options)
    } else {
      api.reload('10a3b918', component.options)
    }
    
  }
}
component.options.__file = "src/pages/Map/components/HeartbeatMarker.vue"
export default component.exports